import { render, staticRenderFns } from "./LueftungsView.vue?vue&type=template&id=c53f0254&"
import script from "./LueftungsView.vue?vue&type=script&lang=js&"
export * from "./LueftungsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports